/*
 *
 * App constants
 *
 */

export const DEFAULT_LOCALE = 'en';
export const STORE_KEY = 'cbApp';
